class ButtonTabController {
    constructor() {
        for (let i = 0, l = this.tabs.length; i < l; i++) {
            if (this.tabs[i].active) {
                this.activeTab = this.tabs[i].name;
                break;
            }
        }

        let self = this;

        let operations = {
            loadTab: (name) => {
                for(let i=0; i<self.tabs.length; i++)
                {
                    if(self.tabs[i].name === name)
                    {
                        self.clickTab(self.tabs[i]);
                    }
                }
            }
        };

        this.onLoaded({operations: operations});
    }

    clickTab(tab) {
        this.activeTab = tab.name;

        if (typeof(tab.click) == 'function') {
            tab.click();
        }
    }
}

export default ButtonTabController;



// WEBPACK FOOTER //
// ./src/app/common/button-tab/button-tab.controller.js